import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ExternalCallPointReportService from '_services/external-call-point-report-service';

export const fetchExternalCallPointReport = createAsyncThunk(
  'externalCallPointReport/fetch',
  async (params, { signal }) => {
    return await ExternalCallPointReportService.getExternalCallPointReport(params, signal);
  }
);

export const patchBooking = createAsyncThunk(
  'externalCallPointReport/patchBooking',
  async ({ bookingId, patch }) => {
    await ExternalCallPointReportService.patchBooking(bookingId, patch);
    return { bookingId, patch };
  }
);

const initialState = {
  data: null,
  status: 'idle',
  error: null,
  patchStatus: 'idle',
  patchError: null,
};

const externalCallPointReportSlice = createSlice({
  name: 'externalCallPointReport',
  initialState,
  reducers: {
    resetExternalCallPointReport: (state) => {
      state.data = null;
      state.status = 'idle';
      state.error = null;
    },
    resetPatchBookingStatus: (state) => {
      state.patchStatus = 'idle';
      state.patchError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExternalCallPointReport.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchExternalCallPointReport.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchExternalCallPointReport.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(patchBooking.pending, (state) => {
        state.patchStatus = 'loading';
        state.patchError = null;
      })
      .addCase(patchBooking.fulfilled, (state) => {
        state.patchStatus = 'succeeded';
        state.patchError = null;
      })
      .addCase(patchBooking.rejected, (state, action) => {
        state.patchStatus = 'failed';
        state.patchError = action.error.message;
      });
  },
});

export const selectExternalCallPointReportData = (state) => state.externalCallPointReport.data;
export const selectExternalCallPointReportStatus = (state) => state.externalCallPointReport.status;
export const selectExternalCallPointReportError = (state) => state.externalCallPointReport.error;
export const selectPatchBookingStatus = (state) => state.externalCallPointReport.patchStatus;
export const selectPatchBookingError = (state) => state.externalCallPointReport.patchError;

export const { resetExternalCallPointReport, resetPatchBookingStatus } = externalCallPointReportSlice.actions;

export default externalCallPointReportSlice.reducer;
